import React from 'react';

import { useIsFeatureFlagEnabled } from '@eluve/smart-blocks';

import { TenantTemplateBundlesListPage } from './template-bundles/TenantTemplateBundlesListPage';
import { TenantOutputTemplatesListPage } from './tenant-specific/TenantOutputTemplatesListPage';

/**
 * Index page for an organization's templates section. Routes to the new
 * template bundle management experience when the TEMPLATE_BUNDLE_MANAGEMENT
 * flag is enabled for the tenant, otherwise falls back to the legacy
 * output templates list.
 */
export const TenantTemplatesIndexPage: React.FC = () => {
  const isTemplateBundleManagementEnabled = useIsFeatureFlagEnabled(
    'TEMPLATE_BUNDLE_MANAGEMENT',
  );

  if (isTemplateBundleManagementEnabled) {
    return <TenantTemplateBundlesListPage />;
  }

  return <TenantOutputTemplatesListPage />;
};
